<script setup>
import BreadCrumbs from '@/components/breadcrumbs/BreadCrumbs.vue'
import ContentSubheaderPage from '@/components/content/ContentSubheaderPage.vue'
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAboutRaaiStore } from '@/store/aboutRaai'

const route = useRoute()
const router = useRouter()

const aboutRaaiStore = useAboutRaaiStore()

const mobileLinks = ref([])
const selectedMobileLink = ref('/about/raai_goals')

const links = ref([])

const handleClick = (id, subLinkId = null) => {
    for (let link of links.value) {
        if (link.id === id) {
            link.isToggle = true
            link.isShow = true
        } else link.isToggle = false

        if (link.pages) {
            for (let subLink of link.pages) {
                subLink.isToggle = false
            }
        }
    }

    if (subLinkId) {
        for (const link of links.value) {
            if (link.id === id) {
                for (let subLink of link.pages) {
                    subLink.isToggle = subLinkId === subLink.id;
                }
            } else {
                if (link.pages) {
                    for (let subLink of link.pages) {
                        subLink.isToggle = false
                    }
                }
            }
        }
    }
}

const toggleDropdown = (id) => {
    for (let link of links.value) {
        if (link.id === id) {
            link.isShow = !link.isShow

            if (link.isShow)
                document.getElementById(
                    `about-dropdown-arrow-${id}`
                ).style.transform = 'rotate(180deg)'
            else
                document.getElementById(
                    `about-dropdown-arrow-${id}`
                ).style.transform = 'rotate(0)'

            return
        }
    }
}

watch(selectedMobileLink, () => {
    router.push(selectedMobileLink.value)
})

onMounted(async () => {
    await aboutRaaiStore.getAboutRaaiSections(true)
    links.value = aboutRaaiStore.aboutRaaiSections

    links.value.map(link => {
        link.isToggle = false
        link.isShow = false

        link.pages.sort((a, b) => a.id - b.id)
        link.href = `/about/${link.id}/${link.pages[0].id}`

        link.pages.map(subLink => {
            subLink.isToggle = false

            if (subLink.id === 9) {
                link.href = '/about/raai_regional_branches/main'
                subLink.href = '/about/raai_regional_branches/main'
            } else {
                subLink.href = `/about/${link.id}/${subLink.id}`
            }
        })

        return link
    })

    links.value.unshift({
        id: -1,
        name: 'Цели и задачи РАИИ',
        href: '/about/raai_goals',
        isToggle: true
    })

    links.value.push({
        id: -2,
        name: 'Список членов РАИИ',
        href: '/about/raai_members',
        isToggle: false
    })

    links.value.push({
        id: -3,
        name: 'Наши потери',
        href: '/about/our_losses',
        isToggle: false
    })

    for (let link of links.value) {
        link.isToggle = route.fullPath.includes(link.href)

        if (link.isShow !== undefined) {
            link.isShow = link.isToggle

            for (const subLink of link.pages) {
                mobileLinks.value.push({
                    title: subLink.title,
                    href: subLink.href
                })
            }
        } else {
            mobileLinks.value.push({
                title: link.name,
                href: link.href
            })
        }
    }

    for (const link of links.value) {
        if (link.isToggle && link.pages) {
            for (let subLink of link.pages) {
                subLink.isToggle = route.fullPath.includes(subLink.href)
            }
        }
    }

    if (route.fullPath.includes('our_losses'))
        selectedMobileLink.value = '/about/our_losses'
    else selectedMobileLink.value = route.fullPath
})
</script>

<template>
    <div
        id="about-page"
        class="container"
    >
        <bread-crumbs />
        <content-subheader-page
            class="about-page-content-subheader"
            text="О РАИИ"
        />
        <v-container
            :fluid="true"
            class="pa-0 about-container"
        >
            <v-select
                v-model="selectedMobileLink"
                :items="mobileLinks"
                class="d-lg-none"
                variant="outlined"
                item-title="title"
                item-value="href"
            />
            <v-row class="ml-n2 mr-n2">
                <v-col
                    class="pl-2 pr-2 d-none d-lg-block"
                    cols="3"
                >
                    <div class="sub-page-links-card">
                        <div
                            v-for="link in links"
                            :key="link.id"
                        >
                            <router-link
                                :to="link.href"
                                class="main-link"
                                :class="{ toggle: link.isToggle }"
                                @click="handleClick(link.id)"
                            >
                                {{ link.name }}
                            </router-link>
                            <span
                                v-if="link.pages !== undefined"
                                class="dropdown-arrow"
                                @click="toggleDropdown(link.id)"
                            >
                                <img
                                    :id="`about-dropdown-arrow-${link.id}`"
                                    src="/svg/dropdown_arrow.svg"
                                    alt="arrow"
                                />
                            </span>
                            <div
                                v-if="
                                    link.pages !== undefined && link.isShow
                                "
                                class="sub-links"
                            >
                                <router-link
                                    v-for="subLink in link.pages"
                                    :key="subLink.id"
                                    :to="subLink.href"
                                    class="sub-link"
                                    :class="{ 'sub-link-toggle': subLink.isToggle }"
                                    @click="handleClick(link.id, subLink.id)"
                                >
                                    {{ subLink.title }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col
                    class="pl-2 pr-2"
                    cols="12"
                    lg="9"
                >
                    <router-view />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<style lang="scss" scoped>
a {
    text-decoration: none;
    color: unset;
}

.container {
    margin-top: 32px;
    margin-left: 104px;
    margin-right: 104px;

    @media screen and (max-width: 767px) {
        margin-left: 40px;
        margin-right: 40px;
        margin-top: 24px;
    }
}

.about-page-content-subheader {
    text-align: left;
}

.about-container {
    margin-top: 28px;
}

.sub-page-links-card {
    box-shadow: 1px 1px 50px 10px #2632380d;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 0 30px 25px;
    text-align: left;
}

.sub-links {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-left: 30px;
    margin-top: 10px;
}

.sub-link {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: #001fa3;

    &:hover {
        text-decoration: underline;
    }
}

.main-link {
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
    color: #002866;
    transition: color 0.2s;

    &:hover {
        color: #0635ac;
    }
}

.dropdown-arrow {
    cursor: pointer;
}

.toggle {
    color: #0635ac;
}

.sub-link-toggle {
    text-decoration: underline;
}
</style>
